import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { CONTACT } from "@/data/site";

const Section = ({ title, children }) => (
  <Reveal>
    <div className="border-t border-ink/10 py-10">
      <h2 className="font-serif text-2xl font-medium text-ink md:text-3xl">{title}</h2>
      <div className="mt-4 space-y-3 text-ink/70 leading-relaxed">{children}</div>
    </div>
  </Reveal>
);

export default function MentionsLegales() {
  return (
    <>
      <Seo title="Mentions légales & CGV" description="Mentions légales, éditeur du site et conditions générales de Désir Events (DESIREVENT 2.0), agence événementielle B2B à Lyon." path="/mentions-legales" />
      <PageHero eyebrow="Informations légales" title={<>Mentions légales<br /><span className="italic text-lime-dim">& CGV</span></>} />

      <section className="mx-auto max-w-3xl px-5 py-16 md:px-10 md:py-24">
        <Section title="Éditeur du site">
          <p><span className="text-ink/45">Raison sociale :</span> {CONTACT.legalName} (« {CONTACT.brand} »)</p>
          <p><span className="text-ink/45">SIRET :</span> {CONTACT.siret}</p>
          <p><span className="text-ink/45">Siège social :</span> {CONTACT.address} — {CONTACT.building}</p>
          <p><span className="text-ink/45">Téléphone :</span> {CONTACT.phoneFixe} · {CONTACT.phoneMobile}</p>
          <p><span className="text-ink/45">Email :</span> {CONTACT.email}</p>
          <p><span className="text-ink/45">Directeur de la publication :</span> Le représentant légal de {CONTACT.legalName}.</p>
          <p><span className="text-ink/45">Activité :</span> Agence événementielle B2B — {CONTACT.zones}.</p>
        </Section>

        <Section title="Hébergement">
          <p><span className="text-ink/45">Hébergeur :</span> Emergent — plateforme cloud d'hébergement d'applications (emergent.sh). Les coordonnées complètes de l'hébergeur ainsi que toute demande relative à l'hébergement peuvent être obtenues auprès de l'éditeur via {CONTACT.email}.</p>
        </Section>

        <Section title="Propriété intellectuelle">
          <p>L'ensemble des contenus de ce site (textes, visuels, logos, vidéos, éléments graphiques) est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de {CONTACT.legalName}, sauf mention contraire. Toute reproduction ou représentation, totale ou partielle, sans autorisation écrite préalable est interdite.</p>
          <p>Les marques et logos de tiers éventuellement cités restent la propriété de leurs détenteurs respectifs.</p>
        </Section>

        <Section title="Données personnelles (RGPD)">
          <p>Les informations recueillies via les formulaires (devis, rappel, contact, candidature) sont destinées exclusivement à {CONTACT.legalName} afin de traiter votre demande. Elles ne sont ni vendues ni cédées à des tiers.</p>
          <p>Conformément au Règlement Général sur la Protection des Données, vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression de vos données. Pour l'exercer, écrivez à {CONTACT.email}.</p>
        </Section>

        <Section title="Cookies">
          <p>Ce site peut utiliser des cookies techniques nécessaires à son bon fonctionnement ainsi que des cookies de mesure d'audience. Vous pouvez configurer votre navigateur pour les refuser.</p>
        </Section>

        <Section title="Conditions générales (extrait)">
          <p>Toute prestation fait l'objet d'un devis détaillé accepté par le client avant exécution. Les conditions complètes (acomptes, annulation, responsabilités, assurances) sont communiquées avec chaque proposition commerciale.</p>
          <p>Disponibilité de l'agence : {CONTACT.availability}.</p>
        </Section>
      </section>
    </>
  );
}
